// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1W_BL","colMaxWidth":"Table_colMaxWidth__31kkD"};